import * as o from "react";
import t from "../lib/IconBase.es.js";
import r from "../defs/PhoneDisconnect.es.js";
const e = o.forwardRef((n, c) => /* @__PURE__ */ o.createElement(t, { ref: c, ...n, weights: r }));
e.displayName = "PhoneDisconnectIcon";
const i = e;
export {
  i as PhoneDisconnect,
  e as PhoneDisconnectIcon
};
